import { useQuery } from "@apollo/client";
import { toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useEffect } from "react";
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import AdminLayout from "src/AdminRoutes/AdminLayout";
import NotFound from "src/Routes/NotFound";
import ProfileSetup from "src/UserRoutes/ProfileSetup";
import TheLayout from "src/UserRoutes/TheLayout";
import styled from "styled-components";
import { CHECK_FOR_SETUP } from "./ProfileCheckQuery.local";

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingText = styled.div`
  color: ${(props) => props.theme.primaryTextColor};
  font-size: 1.2rem;
  text-align: center;
`;
interface IProps extends RouteComponentProps {
  isAdmin: boolean;
}

const ProfileCheck: React.SFC<IProps> = ({ isAdmin }) => {
  let user = auth().currentUser;
  const { data, loading, error, refetch } = useQuery(CHECK_FOR_SETUP, {
    variables: { id: user ? user.uid : "" },
  });

  useEffect(() => {
    if (error) {
      toaster.danger(error.message);
    }
  }, [error]);

  if (!loading && error) {
    if (error.message === "Failed to fetch") {
      return (
        <Container>
          <LoadingText>
            Check your internet connection <br /> or <br />
            try again later! <br />
            <br />
            <br /> Contact admin if you believe this is not your connectivity
            issue.
          </LoadingText>
        </Container>
      );
    }
    return (
      <Container>
        <LoadingText>An error has occured! Try refresh...</LoadingText>
      </Container>
    );
  }

  return loading && !data ? (
    <Container>
      <LoadingText>Verifying account...</LoadingText>
    </Container>
  ) : (
    data &&
      (data.users_by_pk && data.users_by_pk.country ? (
        <Switch>
          {isAdmin && <Route path="/admin" component={AdminLayout} />}
          <Route
            path="/"
            component={(props) => (
              <TheLayout
                isAdmin={isAdmin}
                {...props}
                userInfo={data.users_by_pk}
              />
            )}
          />
          <Route component={NotFound} />
        </Switch>
      ) : (
        <Switch>
          {isAdmin && <Route path="/admin" component={AdminLayout} />}
          <Route
            exact
            path="/"
            component={(props) => (
              <ProfileSetup
                {...props}
                userInfo={data.users_by_pk}
                country={data.country}
                refetch={refetch}
              />
            )}
          />
          <Route
            exact
            path="/referral/:username"
            component={(props) => (
              <ProfileSetup
                {...props}
                userInfo={data.users_by_pk}
                country={data.country}
                refetch={refetch}
              />
            )}
          />
          <Route component={NotFound} />
        </Switch>
      ))
  );
};

export default withRouter(ProfileCheck);
